import { render, staticRenderFns } from "./ihrm.vue?vue&type=template&id=043685a6&scoped=true"
import script from "./ihrm.vue?vue&type=script&lang=js"
export * from "./ihrm.vue?vue&type=script&lang=js"
import style0 from "./ihrm.vue?vue&type=style&index=0&id=043685a6&prod&lang=scss"
import style1 from "./ihrm.vue?vue&type=style&index=1&id=043685a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043685a6",
  null
  
)

export default component.exports